import { createContext, useContext } from "react";

export const SectionsContext = createContext({
  sections: [],
  updateSections: () => {},
  fetchSections : () => {},
  reloadSections: () => {},
  getSectionByName: () => {},
  removeSections: () => {},
  isUpdatedSection: false,
  sectionError: null,
  HideSectionsSkeleton: false,
  setHideSectionsSkeleton: () => {},
});

export const useSectionsContext = () => useContext(SectionsContext);
